/**
 * AIScoreBadge — affiche le score IA 0-100 avec une barre de progression dorée.
 */
import type { JSX } from 'react';

export interface AIScoreBadgeProps {
  score: number;
  compact?: boolean;
}

export function AIScoreBadge({ score, compact = false }: AIScoreBadgeProps): JSX.Element {
  const clamped = Math.max(0, Math.min(100, Math.round(score)));
  return (
    <div
      className="flex items-center gap-2"
      aria-label={`Score IA de priorité : ${clamped} sur 100`}
    >
      <span
        className="text-[11px] font-bold text-[color:var(--color-primary-dark)]"
        style={{ minWidth: compact ? 24 : 28 }}
      >
        {clamped}
      </span>
      <div
        className="relative h-1.5 rounded-full overflow-hidden"
        style={{
          width: compact ? 48 : 72,
          background: 'var(--color-primary-glow)',
        }}
      >
        <div
          className="absolute inset-y-0 left-0 rounded-full"
          style={{
            width: `${clamped}%`,
            background:
              'linear-gradient(90deg, var(--color-primary) 0%, var(--color-primary-dark) 100%)',
          }}
        />
      </div>
    </div>
  );
}
